/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

/* Javascript - Show cart drawer when product added to cart */
document.addEventListener('theme:cart:popdown', (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: false,
      })
    );
    document.removeEventListener('theme:cart:change', listener);
  };
  document.addEventListener('theme:cart:change', listener);
});
/* end */



(function () {
  const TITLE_SELECTOR = ".product__title.heading-size-7";
  const PRICE_SELECTOR = ".product__price.accent-size-4";
  const BUTTON_READY_SELECTOR = ".btn-state-ready.flex.justify-center";

  const DISCOUNT_AMOUNT = 108;
  const MATCH_PHRASE = "Bundle";

  let observer = null;

  function parsePrice(priceText) {
    const match = priceText.replace(/,/g, "").match(/\$?\s*(\d+(?:\.\d{2})?)/);
    if (!match) return null;

    return {
      value: parseFloat(match[1]),
      hasCents: /\.\d{2}/.test(match[1]),
      currencySymbol: priceText.includes("$") ? "$" : ""
    };
  }

  function formatPrice(amount, hasCents, currencySymbol) {
    return currencySymbol + (hasCents ? amount.toFixed(2) : Math.round(amount));
  }

  function shouldApplyDiscount() {
    const titleDiv = document.querySelector(TITLE_SELECTOR);
    return titleDiv && titleDiv.textContent.includes(MATCH_PHRASE);
  }

  function updateAddToCartButton(reducedPriceText) {
    const buttonReadySpan = document.querySelector(BUTTON_READY_SELECTOR);

    if (!buttonReadySpan) return;

    buttonReadySpan.textContent = "Add to Cart • " + reducedPriceText;
  }

  function applyBirthdayBundleDiscount() {
    const priceDiv = document.querySelector(PRICE_SELECTOR);

    if (!priceDiv || !shouldApplyDiscount()) return;

    // Do not reprocess our own adjusted markup
    if (priceDiv.dataset.birthdayBundleAdjusted === "true") {
      const discountedPriceSpan = priceDiv.querySelector(".birthday-bundle-discounted-price");

      if (discountedPriceSpan) {
        updateAddToCartButton(discountedPriceSpan.textContent.trim());
      }

      return;
    }

    const parsed = parsePrice(priceDiv.textContent);
    if (!parsed || isNaN(parsed.value)) return;

    const originalPrice = parsed.value;
    const discountedPrice = originalPrice - DISCOUNT_AMOUNT;

    if (discountedPrice < 0) return;

    const discountedPriceText = formatPrice(
      discountedPrice,
      parsed.hasCents,
      parsed.currencySymbol
    );

    const originalPriceText = formatPrice(
      originalPrice,
      parsed.hasCents,
      parsed.currencySymbol
    );

    // Temporarily stop observing before changing the watched price element
    if (observer) observer.disconnect();

    priceDiv.dataset.birthdayBundleAdjusted = "true";

    priceDiv.innerHTML = `
      <span class="birthday-bundle-discounted-price">
        ${discountedPriceText}
      </span>
      <span class="birthday-bundle-original-price" style="text-decoration: line-through; margin-left: 8px; opacity: 0.65;">
        ${originalPriceText}
      </span>
    `;

    updateAddToCartButton(discountedPriceText);

    observePriceChanges();
  }

  function observePriceChanges() {
    const priceDiv = document.querySelector(PRICE_SELECTOR);
    if (!priceDiv) return;

    if (observer) observer.disconnect();

    observer = new MutationObserver(function () {
      const priceDiv = document.querySelector(PRICE_SELECTOR);

      if (!priceDiv || !shouldApplyDiscount()) return;

      const hasOurMarkup = priceDiv.querySelector(".birthday-bundle-original-price");

      if (!hasOurMarkup) {
        priceDiv.dataset.birthdayBundleAdjusted = "false";
        applyBirthdayBundleDiscount();
      } else {
        const discountedPriceSpan = priceDiv.querySelector(".birthday-bundle-discounted-price");

        if (discountedPriceSpan) {
          updateAddToCartButton(discountedPriceSpan.textContent.trim());
        }
      }
    });

    observer.observe(priceDiv, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function initBirthdayBundleDiscount() {
    applyBirthdayBundleDiscount();
    observePriceChanges();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBirthdayBundleDiscount);
  } else {
    initBirthdayBundleDiscount();
  }
})();





(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    console.log('Checking Container and Variant ———————— ↓');    
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page

        const titleEl = document.querySelector('.product__title.heading-size-7');

        if (titleEl) {
          const text = titleEl.textContent || '';

          if (text.includes('Blue Birthday Bundle')) {


          compare = document.getElementById("amount-off");
          compare_price_2 = variant.price/100 + 76;
          compare.textContent = "$" + compare_price_2.toFixed(2);

        }
      }
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
